import React from 'react';
import { styles } from './AlphabeticalLinksList.css';
import { Link as LinkComponent } from '../PlatformFunctionality';

type Link = {
  href: string;
  label: string;
};

export type AlphabeticalLinksListProps = {
  links: Array<Link>;
  order?: 'asc' | 'desc';
  onLinkClick?: (link: Link) => void;
};

export const AlphabeticalLinksList = ({ links, order = 'asc', onLinkClick }: AlphabeticalLinksListProps) => {
  const groupedLinks = groupLinksByFirstLetter(links, order);

  return (
    <div className={styles.container}>
      {groupedLinks.map(({ letter, links }) => (
        <div key={letter} className={styles.linksGroup}>
          <p className={styles.linksGroupHeading}>
            <strong>{letter}</strong>
          </p>
          <ul className={styles.linksUnorderedList}>
            {links.map((link, i) => (
              <li key={i}>
                <LinkComponent className={styles.link} href={link.href} onClick={() => onLinkClick?.(link)}>
                  {link.label}
                </LinkComponent>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

type GroupedLinks = Array<{ letter: string; links: Array<Link> }>;

const groupLinksByFirstLetter = (links: Array<Link>, order: 'asc' | 'desc') => {
  const groupedLinks = links.reduce((acc: GroupedLinks, link) => {
    const firstLetter = getFirstLetter(link.label);
    let group = acc.find(group => group.letter === firstLetter);
    if (!group) {
      group = { letter: firstLetter, links: [] };
      acc.push(group);
    }
    group.links.push(link);
    return acc;
  }, []);
  groupedLinks.sort(
    order === 'asc' ? (a, b) => a.letter.localeCompare(b.letter) : (a, b) => b.letter.localeCompare(a.letter)
  );
  return groupedLinks;
};

const getFirstLetter = (str: string) => {
  return (
    str
      .replace(/[^a-zA-Z]/g, '')
      .charAt(0)
      .toUpperCase() || '#'
  );
};
